export const handleIframeMessage = () => {
    function findIframe(frameElement) {
        var iframeList = document.querySelectorAll('iframe');

        for (var i = 0; i < iframeList.length; ++i) {
            if (iframeList[i].contentWindow === frameElement) {
                return iframeList[i];
            }
        }
    }

    function receiveMessage(e) {
        try {
            var data = JSON.parse(e.data);
            var height = data['iframe-height'];
            var width = data['iframe-width'];
            var iframe = findIframe(e.source);

            if (iframe && height && width) {
                iframe.style.height = height + 'px';
                iframe.style.width = width + 'px';
            }
        } catch (err) {
        }
    }

    window.addEventListener('message', receiveMessage, false);
};
